<template>
  <CardItem
      v-if="thankyouScreen"
      :show-top-bar="false"
      :options="options"
  >
    <div class="flex flex-grow items-center justify-center">
      <TextTitle>
        <template #icon>
          <a-icon
              v-if="imageType === 'default'"
              type="check-circle"
          />
        </template>
        {{ title }}
        <template #description>
          <TextCollapsed
              :title="description"
              :max-length="300"
          />
        </template>
      </TextTitle>
    </div>
    <template #button>
      <a
          v-if="showButton"
          :href="buttonUrl"
          target="_parent">
        <a-button
            type="primary"
            class="btn-action-primary"
            :style="[buttonBgColor, buttonTextColor]">
          {{ buttonText }}
        </a-button>
      </a>
    </template>
  </CardItem>
</template>

<script>
import {mapGetters} from "vuex";
import {isCreatorMode, parseImgUrl, redirect} from "../../helpers/fns";
import CardItem from "../CardItem";
import themeMixin from "../../mixins/theme.mixin";
import TextCollapsed from "../TextCollapsed";
import TextTitle from "../TextTitle";

export default {
  name: "ScreenThankyou",
  props: {
    thankyouId: {
      type: String,
      default: null,
    },
  },
  filters: {parseImgUrl},
  mixins: [themeMixin],
  components: {CardItem, TextCollapsed, TextTitle},
  mounted() {
    if (
        !isCreatorMode &&
        this.thankyouScreen?.redirect?.isActive &&
        this.thankyouScreen?.redirect?.link
    ) {
      redirect(this.thankyouScreen?.redirect?.link);
    }
  },
  computed: {
    ...mapGetters(["survey"]),
    thankyouScreen: function () {
      const thankyou = this.survey.thankyouScreens.find(t => t._id === this.thankyouId) || this.survey.thankyouScreens[0]
      return thankyou?.isActive ? thankyou : {}
    },
    title() {
      return this.thankyouScreen.title || this.survey.translations?.thankyouScreen?.title?.defaultValue || "";
    },
    description() {
      return this.thankyouScreen.description || "";
    },
    imageType() {
      return this.thankyouScreen.image?.type || "default";
    },
    imageSrc() {
      return this.thankyouScreen.image?.src || "";
    },
    buttonText() {
      return this.thankyouScreen.button?.text;
    },
    buttonUrl() {
      return this.thankyouScreen.button?.link;
    },
    showButton: function () {
      return this.thankyouScreen.button?.isActive
    },
    options() {
      return (this.imageType === 'custom' && this.imageSrc)
          ? {imgSrc: this.imageSrc}
          : {};
    }
  },
}
</script>

<style lang="less" scoped>

</style>
